export const ListQueryKey = 'welfareCates';
export const DetailQueryKey = 'welfareCate';

export const Urls = {
  selectUrl: '/welfareProjectCate/list',
  updateUrl: '/welfareProjectCate/update',
  deleteUrl: '/welfareProjectCate/delete',
  createUrl: '/welfareProjectCate/create',
  detailUrl: '/welfareProjectCate/detail',
};
// /api/welfareProjectCate/list
